import Repository from "../Repository";

const resource = "/product/molded-seat";

export default {
  async get(molded_seat_uuid) {
    return Repository.get(`${resource}/${molded_seat_uuid}`);
  },

  async getMoldedSeat(molded_seat_uuid) {
    return Repository.get(`${resource}/${molded_seat_uuid}`);
  },

  /**
   * Create molded seat product on server
   * @param {Object} payload Product payload
   */
  async create(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
